exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-3XHpo{background-color:#042b75;border:solid 1px #001240;padding:20px;margin-bottom:40px}.collapseContainer-OCeie{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.filters-1yX3W{margin-bottom:-20px}.buttonsContainer-1ID27{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:40px}.buttonsContainer-1ID27 button{width:300px}.withCollapse-xcVBE{margin-bottom:40px}", ""]);

// exports
exports.locals = {
	"container": "container-3XHpo",
	"collapseContainer": "collapseContainer-OCeie",
	"filters": "filters-1yX3W",
	"buttonsContainer": "buttonsContainer-1ID27",
	"withCollapse": "withCollapse-xcVBE"
};